import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import Panels from './Panels';
import { useApi } from 'src/@context/Api';
import { Link } from 'react-router-dom';
import { secondaryColor, tertiaryColor } from 'src/constants/stylesheet';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.Gutter.Mobile / 2,
        paddingRight: spacing.Gutter.Mobile / 2,
        paddingTop: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
        paddingTop: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
        paddingTop: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
        paddingTop: spacing.Gutter.Desktop,
        paddingBottom: spacing.Gutter.Desktop,
      },
    },
    rootInner: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    backToOverview: {
      display: 'inline-block',
      fontSize: '1rem',
      cursor: 'pointer',
      color: 'white',
      backgroundColor: secondaryColor,
      maringTop: 10,
      padding: '4px 30px',
      textTransform: 'uppercase',

      '&:hover': {
        backgroundColor: tertiaryColor
      },

      [mediaQueries.Mobile]: {
        marginLeft: spacing.Gutter.Mobile / 2,
        marginRight: spacing.Gutter.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        marginLeft: spacing.Gutter.Tablet / 2,
        marginRight: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        marginLeft: spacing.Gutter.Laptop / 2,
        marginRight: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        marginLeft: spacing.Gutter.Desktop / 2,
        marginRight: spacing.Gutter.Desktop / 2,
      },
    }
  }));
export type ProjectProps = ProjectDto;

type Props = ProjectProps;

const Project: FC<Props> = ({ Panels: panels }) => {
  const cls = useStyles();
  const { app } = useApi();

  const porjectsLink = app && app.Menus.find(m => m.type === 'Projects');

  return (
    <div className={cls.root}>
      <div className={cls.rootInner}>
        <Panels panels={panels} />
      </div>
      {porjectsLink &&
        <Link
          className={cls.backToOverview}
          to={`/${porjectsLink.UID}`}
        >
          Revenir
        </Link>
      }
    </div>
  );
};

export default Project;



// WEBPACK FOOTER //
// ./src/Components/Project.tsx